// // src/Router.js
// import React from "react";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
// } from "react-router-dom";
// import Auth from "../pages/auth/login";
// import OTP from "../pages/auth/otp";
// import Register from "../pages/auth/register";
// import Tickets from "../pages/tickets/tickets";
// import Quiz from "../pages/quiz/quiz";
// import Result from "../pages/result/result";
// import TicketDetails from "../pages/tickets/ticketDetails";
// import LotteryAccountDetails from "../pages/lotteryAcount/lotteryAccountDetails";
// import Wallet from "../pages/wallet/wallet";
// import LotteryResult from "../pages/result/lotteryResult";
// import {
//   PrivateRoutes,
//   PublicRoutes,
//   RegisterRoutes,
// } from "../utilities/protectedRoutes/authRoutes";
// import AccountStatement from "../pages/lotteryAcount/accountStatement";
// import PurchasedTickets from "../pages/tickets/purchasedTickets";
// import PaymentTransactions from "../pages/razorpayTransactions/paymentTransactions";
// import Profile from "../components/profile";
// import Withdraw from "../pages/withdraw/withdraw";
// import Layout from "../Layout";
// import WithdrawRequest from "../pages/withdraw/withdrawRequest";
// import SetPassword from "../pages/auth/setPassword";

// const AppRouter = () => {
//   const isAuthenticated = () => {
//     // Check if the user is logged in
//     return Boolean(localStorage.getItem("isLoggedIn"));
//   };

//   const isVerified = () => {
//     // Check if the user has verified OTP
//     return Boolean(localStorage.getItem("isOTPVerified"));
//   };

//   const isRegistered = () => {
//     // Check if the user has completed registration
//     return Boolean(localStorage.getItem("is_verified"));
//   };

//   // Protect the home page from unregistered users
//   const ProtectedHomeRoute = ({ children }) => {
//     if ( !isRegistered()) {
//       // Redirect to the register page if registration is incomplete
//       return <Navigate to="/register" replace />;
//     }

//     return children;
//   };

//   const ProtectedOTPRoute = ({ children }) => {
//     // Redirect to login if not authenticated
//     if (!isAuthenticated()) {
//       return <Navigate to="/login" replace />;
//     }

//     // If both conditions are satisfied, render the children
//     return children;
//   };

//   const ProtectedRegisterRoute = ({ children }) => {
//     // Redirect to login if OTP is not verified
//     if (!isVerified()) {
//       return <Navigate to="/login" replace />;
//     }

//     return children;
//   };

//   return (
//     <Router>
//       <Routes>
//         {/* Public Routes */}
//         <Route element={<PublicRoutes />}>
//           <Route path="/login" element={<Auth />} />
//           <Route path="/set-password" element={<SetPassword />} />
//           <Route
//             path="/otp"
//             element={
//               <ProtectedOTPRoute>
//                 <OTP />
//               </ProtectedOTPRoute>
//             }
//           />
//         </Route>

//         {/* Register Routes */}
//         <Route element={<RegisterRoutes />}>
//           <Route
//             path="/register"
//             element={
//               <ProtectedRegisterRoute>
//                 <Register />
//               </ProtectedRegisterRoute>
//             }
//           />
//         </Route>

//         {/* Private Routes */}
//         <Route element={<PrivateRoutes />}>
//           <Route
//             path="/"
//             element={
//               <ProtectedHomeRoute>
//                 <Layout />
//               </ProtectedHomeRoute>
//             }
//           >
//             <Route index element={<Tickets />} />
//             <Route path="/ticket-details" element={<TicketDetails />} />
//             <Route path="/quiz" element={<Quiz />} />
//             <Route path="/result" element={<Result />} />
//             <Route
//               path="/lottery-account"
//               element={<LotteryAccountDetails />}
//             />
//             <Route path="/wallet" element={<Wallet />} />
//             <Route path="/lottery-result" element={<LotteryResult />} />
//             <Route path="/acc-statement" element={<AccountStatement />} />
//             <Route path="/tickets-history" element={<PurchasedTickets />} />
//             <Route
//               path="/payment-transactions"
//               element={<PaymentTransactions />}
//             />
//             <Route path="/profile" element={<Profile />} />
//             <Route path="/withdraw" element={<Withdraw />} />
//             <Route path="/withdraw-request" element={<WithdrawRequest />} />
//           </Route>
//         </Route>

//         {/* Catch-all route for undefined paths */}
//         {/* Uncomment the next line if you have a NotFound component */}
//         {/* <Route path="*" element={<NotFound />} /> */}
//       </Routes>
//     </Router>
//   );
// };

// export default AppRouter;

// src/Router.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Auth from "../pages/auth/login-auth";
import OTP from "../pages/auth/otp";
import Register from "../pages/auth/register";
import Tickets from "../pages/tickets/tickets";
import Quiz from "../pages/quiz/quiz";
import Result from "../pages/result/result";
import TicketDetails from "../pages/tickets/ticketDetails";
import LotteryAccountDetails from "../pages/lotteryAcount/lotteryAccountDetails";
import Wallet from "../pages/wallet/wallet";
import LotteryResult from "../pages/result/lotteryResult";
import {
  PrivateRoutes,
  PublicRoutes,
  RegisterRoutes,
} from "../utilities/protectedRoutes/authRoutes";
import AccountStatement from "../pages/lotteryAcount/accountStatement";
import PurchasedTickets from "../pages/tickets/purchasedTickets";
import PaymentTransactions from "../pages/razorpayTransactions/paymentTransactions";
import Profile from "../components/profile";
import Withdraw from "../pages/withdraw/withdraw";
import Layout from "../Layout";
import WithdrawRequest from "../pages/withdraw/withdrawRequest";
import SetPassword from "../pages/auth/setPassword";
import Signup from "../pages/auth/user-signup";

const AppRouter = () => {
  // const isAuthenticated = () => {
  //   // Check if the user is logged in
  //   return Boolean(localStorage.getItem("isLoggedIn"));
  // };

  // const ProtectedOTPRoute = ({ children }) => {
  //   // Redirect to login if not authenticated
  //   if (!isAuthenticated()) {
  //     return <Navigate to="/login" replace />;
  //   }

  //   return children;
  // };

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicRoutes />}>
          <Route path="/login" element={<Auth />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/sign-up" element={<Signup/>} />
        </Route>

        {/* Private Routes */}
        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Tickets />} />
            <Route path="/ticket-details" element={<TicketDetails />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/result" element={<Result />} />
            <Route 
              path="/lottery-account"
              element={<LotteryAccountDetails />}
            />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/lottery-result" element={<LotteryResult />} />
            <Route path="/acc-statement" element={<AccountStatement />} />
            <Route path="/tickets-history" element={<PurchasedTickets />} />
            <Route
              path="/payment-transactions"
              element={<PaymentTransactions />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/withdraw" element={<Withdraw />} />
            <Route path="/withdraw-request" element={<WithdrawRequest />} />
          </Route>
        </Route>

        {/* Catch-all route for undefined paths */}
        {/* Uncomment the next line if you have a NotFound component */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Router>
  );
};

export default AppRouter;
